import {
  SUBSCRIBE,
  UPDATE_CARD
} from '../actions'

const initialState = {
  purchasing: false,
  error: false,
  message: null,
}

export default function checkout(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CARD:
    case SUBSCRIBE:
      if (action.error) {
        return {
          ...state,
          loggingIn: false,
          purchasing: false,
          error: true,
          message: action.payload.message,
        }
      }
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
